module.exports = __webpack_public_path__ + "static/media/4ODA2.ab4faad8.jpg";